const authorizedDealer = {
  authorizedDealer: {
    dealerId: 'Authorized Subcontractor',
    city: 'City',
    state: 'State',
    country: 'Country',
    noDealer: '** No Authorized Subcontractor Available **',
    heading: 'Authorized Subcontractor',
    addDealerButton: '+ Add Authorized Subcontractor',
    cancel: 'CANCEL',
    addSubcontractor: 'ADD SUBCONTRACTOR',
    searchContractor: 'SEARCH SUBCONTRACTOR',
    show: 'Show',
    to: 'to',
    of: 'of',
    delete: 'Delete',
    name: 'Name',
    enabled: 'Enabled',
    disabled: 'Disabled',
    status: 'Status',
    footer: 'Authorized Subcontractors'
  }
};

export default authorizedDealer;
